export default __webpack_public_path__ + "1.18.12/static/media/LibreDataShare.42dcc986.svg";